import { useMutation } from "@apollo/client";
import { InviteToShareGoalMutation, InviteToShareGoalMutationVariables } from "@ctypes";
import { INVITE_TO_SHARE_GOAL, SENT_SHARE_GOAL_INVITES, USER } from "@graphql";
import { ShareGoalContactRouteParams } from "@routes/ShareGoalContactRoute/types";
import { useLocation } from "react-router-dom";

export const useInviteToShareGoal = () => {
  const location = useLocation();

  const goalId = (location.state as ShareGoalContactRouteParams).goalId;

  return useMutation<InviteToShareGoalMutation, InviteToShareGoalMutationVariables>(
    INVITE_TO_SHARE_GOAL,
    {
      refetchQueries: [{ query: USER }, { query: SENT_SHARE_GOAL_INVITES, variables: { goalId } }],
      awaitRefetchQueries: true,
    },
  );
};
